import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: ProductDetailsQtyBtnsRowStyles;
}

export interface ProductDetailsQtyBtnsRowStyles {
    container?: InjectableCss;
    wrapper?: InjectableCss;
    middleItem?: InjectableCss;
    lastItem?: InjectableCss;
}

export const productDetailsQtyBtnsRowStyles: ProductDetailsQtyBtnsRowStyles = {
    container: {
        css: css`
            > div {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                gap: 15px;

                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [{ values: ["wrap", null, "nowrap", null, null], properties: ["flex-wrap"] }],
                        mediaOptions.min,
                    )}
            }
        `,
    },
};

const ProductDetailsQtyBtnsRow: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(productDetailsQtyBtnsRowStyles, extendedStyles));
    return (
        <StyledWrapper {...styles.container}>
            <Zone zoneName="Buttons" contentId={id} />
        </StyledWrapper>
    );
};

const storeProductDetailsQtyBtnsRow: WidgetModule = {
    component: connect()(ProductDetailsQtyBtnsRow),
    definition: {
        displayName: "Qty Btns Row",
        group: "Product Details",
    },
};

export default storeProductDetailsQtyBtnsRow;
